import React from 'react';
import { Radio, Divider } from 'cdk-radial';
import "./radioButton.scss";

const RadioButton = ({label, id, isChecked, onSelection, isLast}) => {

    const onRadioChange = () => {
        onSelection(id);
    }

    return (
        <div className='radio-button-padding'>
            <Radio 
            className={isChecked ? 'radio-button-selected' : 'radio-button'}
            checked={isChecked} label={label} onChange={onRadioChange} />
            {isLast ? null : <Divider style={{marginTop:'15px'}}/>}
        </div>
    )
}

export default RadioButton;